import createReducer from "../../createReducer";
import { hubspotAuthHandlers } from "../handlers";
import { IHubspotAuthState } from "../types";

export const hubspotAuthUrlInitialState: IHubspotAuthState = {
    isLoading: false,
    error: null,
    authUrl: null,
};

export default createReducer(hubspotAuthUrlInitialState, hubspotAuthHandlers);
